<!--
    描述：业务字段页面
    时间：2020-05-18
    Created by yefan
-->
<template>
    <div class="w-page-main">
        <!-- 顶部搜索栏 -->
        <div class="w-page-header">
            <div class="left-text overflow-hidden">
                <span><b style="color: red">所有公共字段谨慎删除，如需测试删除功能，建议新增字段删除！</b></span>
            </div>
            <search-area ref="searchContent" v-model="searchForm.title" placeholderName="业务字段名称"
                         @on-search="onSearch" @on-refresh="onRefresh" @on-reset="onReset">
                <el-form slot="searchform" :model="searchForm" label-width="90px">
                    <el-form-item label="字段类型">
                        <el-select v-model="searchForm.formType" placeholder="请选择类型">
                            <el-option v-for="(item) in typeList" :key="item.value" :label="item.sname"
                                       :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </search-area>
            <div class="btnGroups ml10">
                <el-button type="success" size="small" @click="exportExcel">导出Excel</el-button>
                <el-button type="primary" size="small" @click="doClick('add')">新增字段</el-button>
            </div>
        </div>

        <!-- 下方内容 -->
        <div class="w-page-container">
            <businessFieldList ref="listTable" @doClick="doClick"></businessFieldList>
        </div>

        <!-- 新增、编辑等弹窗 -->
        <el-dialog :title="dialogObj.title" :visible.sync="dialogObj.visible" :width="dialogObj.width"
                   :close-on-click-modal="false">
            <!-- 弹窗组件 -->
            <fieldItemAdd ref="fieldItemAdd" :fieldId="fieldId" :mode="dialogObj.mode" v-if="dialogObj.visible"
                          @dialogClose="dialogClose"></fieldItemAdd>
            <!-- footer 组件 -->
            <div slot="footer" class="dialog-footer text-center" v-if="dialogObj.mode !== 'view'">
                <el-button size="small" @click="dialogObj.visible = false">取 消</el-button>
                <el-button type="primary" size="small" :loading="btnLoading" @click="doSave">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import searchArea from '../../../components/searchArea/searchArea'
    import businessFieldList from './components/business_field_list'
    import fieldItemAdd from './components/field_item_add'
    import {deleteField} from '@/api/modules/analysis.js'
    import {mapState} from "vuex";

    export default {
        components: {searchArea, businessFieldList, fieldItemAdd},
        data() {
            return {
                searchForm: {
                    title: '',
                    formType: ''
                },
                dialogObj: {
                    title: '',
                    visible: false,
                    width: '500px',
                    mode: 'add',
                },
                fieldId: '',
                btnLoading: false
            }
        },

        methods: {
            //新增字段按钮事件
            doClick(type, row) {
                if (type === 'delete') {
                    let that = this;
                    this.$confirm('确认删除吗?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        let param = {};
                        param.id = row.id;
                        deleteField(param).then(res => {
                            if (res.code == 0) {
                                that.$message({message: '删除成功', type: 'success'})
                                that.$refs.listTable.searchPageList(this.searchForm);
                            } else {
                                that.$message({message: res.msg, type: 'error'})
                            }
                        })
                    })
                } else {
                    this.dialogObj.visible = true;
                    this.dialogObj.mode = type;
                    if (type !== 'add') this.fieldId = row.id;
                    if (type === 'add') {
                        this.dialogObj.title = "新增字段";
                    } else if (type === 'edit') {
                        this.dialogObj.title = "编辑字段";
                    } else {
                        this.dialogObj.title = "查看字段";
                    }
                }
            },

            //导出Excel按钮事件
            exportExcel() {
                this.$refs.listTable.exportExcel();
            },

            //新增、编辑业务字段弹框确定按钮事件
            doSave() {
                this.$refs.fieldItemAdd.doSave();
            },

            // 确认搜索
            onSearch() {
                this.$refs.listTable.searchPageList(this.searchForm);
            },

            // 点击刷新
            onRefresh() {
                this.onReset();
                this.onSearch()
            },

            // 点击重置
            onReset() {
                this.searchForm.title = '';
                this.searchForm.formType = ''
            },

            dialogClose() {
                this.dialogObj.visible = false;
                this.$refs.listTable.searchPageList(this.searchForm);
            }
        },

        computed: {
            ...mapState('dict', {
                typeList: state => state.bdlx, // 表单类型
            })
        },
    }
</script>

<style scoped></style>